import React, {useEffect} from 'react';
import stile from './stile.module.css';
import IconaMenu from './IconaMenu';
import logo from '../immagini/logoTitolo.jpeg';
import logoGSDaicon from '../immagini/logoGS-Daicon.png';

function Informazioni(props) {
    var iconaRicarica = require('./cerchio_vuoto.png');
    var iconaIndietro = require('./annulla.png');

    // gestione del tasto BACK
    useEffect(() => {
        if (props.flagRichiestaBack) {
            props.setFlagRichiestaBack(false);
            props.callback(props.PAGINECLIENTI.impostazioni);            
        } 
    }, [props.flagRichiestaBack])

    return (
        <div class={stile.contenitoreBody} style={{flex:1}}>                
            <div style={{ textAlign: 'center', marginTop:20, marginBottom:30, width: "100%", color:"#FFFFFF" }} >
                {props.brand == "" && <img style={{height:"50px", margin:5, border:"1px solid #bfbfbfff", borderRadius:"10px"}} src={logo} alt={"Gestione Sportiva"}/>}
                {props.brand == "daicon" && <img style={{height:"50px", margin:5, border:"1px solid #bfbfbfff", borderRadius:"10px"}} src={logoGSDaicon} alt={"Gestione Sportiva"}/>}
                <br/>
                GS app vers. {props.VersioneApp}
            </div>


            <div
                style={{
                flexGrow: 1,
                display: "flex",
                flexDirection: "column",
                justifyContent: "center", // Centra verticalmente (perché la flexDirection è column) tutto il contenuto
                marginLeft: 5,
                marginRight: 5,
                }}
            >
                <div style={{display:"flex", flexDirection:"row", justifyContent:"center"}}>
                    <IconaMenu
                        callback={() => window.location.reload()}
                        immagine={iconaRicarica}
                        testo={"Aggiorna App"}
                    />
                    <IconaMenu
                        callback={() => { props.callback(props.PAGINECLIENTI.impostazioni) }}
                        immagine={iconaIndietro}
                        testo={"Torna indietro"}
                    />
                </div>

            </div>
        </div>
    );
}

export default Informazioni;
